/**
 * 燃油价格管理 — 常量定义
 */

// 价格周期状态
export const FUEL_PRICE_STATUS = {
    DRAFT: 'DRAFT',
    PENDING_CONFIRMATION: 'PENDING_CONFIRMATION',
    CONFIRMED: 'CONFIRMED',
    DISPUTED: 'DISPUTED',
};

// 状态显示标签
export const FUEL_PRICE_STATUS_LABELS = {
    [FUEL_PRICE_STATUS.DRAFT]: '草稿',
    [FUEL_PRICE_STATUS.PENDING_CONFIRMATION]: '待确认',
    [FUEL_PRICE_STATUS.CONFIRMED]: '已确认',
    [FUEL_PRICE_STATUS.DISPUTED]: '异常',
};

// 状态颜色（Ant Design Tag color）
export const FUEL_PRICE_STATUS_COLORS = {
    [FUEL_PRICE_STATUS.DRAFT]: 'default',
    [FUEL_PRICE_STATUS.PENDING_CONFIRMATION]: 'processing',
    [FUEL_PRICE_STATUS.CONFIRMED]: 'success',
    [FUEL_PRICE_STATUS.DISPUTED]: 'error',
};

// 价格来源
export const PRICE_SOURCE = {
    MANUAL_INPUT: 'MANUAL_INPUT',
    EMAIL_AGENT: 'EMAIL_AGENT',
};

export const PRICE_SOURCE_LABELS = {
    [PRICE_SOURCE.MANUAL_INPUT]: '手动录入',
    [PRICE_SOURCE.EMAIL_AGENT]: 'Agent 提取',
};

export const PRICE_SNAPSHOT_ROLE = {
    INTERNAL_REFERENCE: 'INTERNAL_REFERENCE',
    SUPPLIER_QUOTE: 'SUPPLIER_QUOTE',
};

export const PRICE_SNAPSHOT_ROLE_LABELS = {
    [PRICE_SNAPSHOT_ROLE.INTERNAL_REFERENCE]: '我方参考快照',
    [PRICE_SNAPSHOT_ROLE.SUPPLIER_QUOTE]: '供应商报价快照',
};

export const PRICE_SNAPSHOT_ROLE_COLORS = {
    [PRICE_SNAPSHOT_ROLE.INTERNAL_REFERENCE]: 'geekblue',
    [PRICE_SNAPSHOT_ROLE.SUPPLIER_QUOTE]: 'gold',
};

export const FUEL_PRICE_WORKBENCH_TABS = {
    WORKBENCH: 'workbench',
    LOGS: 'logs',
    MARKET_REFERENCE: 'market-reference',
};

export const FUEL_PRICE_WORKBENCH_TAB_QUERY_KEY = 'tab';

// 操作类型
export const OPERATION_TYPES = {
    PERIOD_CREATED: 'PERIOD_CREATED',
    PERIOD_UPDATED: 'PERIOD_UPDATED',
    PERIOD_DELETED: 'PERIOD_DELETED',
    OUR_PRICE_UPDATED: 'OUR_PRICE_UPDATED',
    SUPPLIER_QUOTE_UPDATED: 'SUPPLIER_QUOTE_UPDATED',
    STATUS_CHANGED: 'STATUS_CHANGED',
};

export const OPERATION_TYPE_LABELS = {
    [OPERATION_TYPES.PERIOD_CREATED]: '创建周期',
    [OPERATION_TYPES.PERIOD_UPDATED]: '更新周期',
    [OPERATION_TYPES.PERIOD_DELETED]: '删除周期',
    [OPERATION_TYPES.OUR_PRICE_UPDATED]: '更新预算价',
    [OPERATION_TYPES.SUPPLIER_QUOTE_UPDATED]: '录入供应商价',
    [OPERATION_TYPES.STATUS_CHANGED]: '状态变更',
};

// 计价单位
export const PRICE_UNITS = ['MT', 'KG', 'L', 'GAL', 'USG'];

// 默认分页
export const DEFAULT_PAGE_SIZE = 20;
